import React from 'react';
import 'tailwindcss/tailwind.css';

const Contact = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="text-center">
          <h1 className="text-4xl font-bold text-gray-900 mb-8">Contact</h1>
          <div className="flex justify-center">
            <div className="bg-white shadow-lg rounded-lg p-8 w-full max-w-md">
              <h2 className="text-2xl font-semibold text-gray-800 mb-4 text-center">Contactgegevens</h2>
              <div className="space-y-4">
                <div>
                  <h3 className="text-lg font-medium text-gray-800">Adres</h3>
                  <p className="text-gray-600">Rooseveltstraat 45D</p>
                  <p className="text-gray-600">2321 BL Leiden</p>
                </div>
                <div>
                  <h3 className="text-lg font-medium text-gray-800">Telefoon</h3>
                  <p className="text-gray-600">+31 (0)6 537 295 62</p>
                </div>
                <div>
                  <h3 className="text-lg font-medium text-gray-800">Email</h3>
                  <p className="text-gray-600">info@autotheker.nl</p>
                </div>
                <div>
                  <h3 className="text-lg font-medium text-gray-800">Openingstijden</h3>
                  <p className="text-gray-600">Wij zijn uitsluitend geopend op afspraak</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
